import Gallery from './Gallery.vue'

export default Gallery
